import { useRecoilValue } from 'recoil';
import {
  HiOutlineHome, HiOutlineBuildingOffice2, HiOutlineClipboardDocumentCheck,
  HiOutlineAdjustmentsHorizontal, HiOutlineCreditCard, HiOutlineCog6Tooth, HiOutlineUser,
  HiOutlineEye
} from 'react-icons/hi2';
import { SidebarMenuItem } from '../types/types';

import { SidebarMenu } from '../components/sidebar/sidebar-menu';
import { ROUTES } from '../helpers/constants';
import { userAtom } from '../services/atoms/auth.atoms';

interface props {
  user?: any
}

// `match`: otras rutas que dejan el ítem marcado como activo (p. ej. el detalle
// de un cliente o de un colaborador cuelga de "Clientes").
const items: SidebarMenuItem[] = [
  { id: 'item-0', label: 'Inicio', icon: HiOutlineHome, url: ROUTES.HOME.route },
  { id: 'item-1', label: 'Clientes', icon: HiOutlineBuildingOffice2, url: ROUTES.CLIENTS.route },
  { id: 'item-2', label: 'Evaluaciones', icon: HiOutlineClipboardDocumentCheck, url: ROUTES.PROCESS.route },
  { id: 'item-3', label: 'Parámetros', icon: HiOutlineAdjustmentsHorizontal, url: ROUTES.PARAMS.route },
  { id: 'item-5', label: 'Pagos por asignar', icon: HiOutlineCreditCard, url: ROUTES.GUEST_PAYMENTS.route },
  { id: 'item-4', label: 'Configuraciones', icon: HiOutlineCog6Tooth, url: ROUTES.CONFIGURATION.route },
];

const itemsAdmin: SidebarMenuItem[] = [
  { id: 'item-0', label: 'Inicio', icon: HiOutlineHome, url: ROUTES.HOME.route },
  { id: 'item-1', label: 'Mi empresa', icon: HiOutlineBuildingOffice2, url: ROUTES.CLIENTS.route },
  { id: 'item-2', label: 'Mi perfil', icon: HiOutlineUser, url: ROUTES.CONFIGURATION.route },
];

// Abajo del todo del menú, separado del resto (solo superadmins).
const bottomItemsSuperAdmin: SidebarMenuItem[] = [
  { id: 'item-test-preview', label: 'Vista previa del test', icon: HiOutlineEye, url: ROUTES.TEST_PREVIEW.route },
];

const Sidebar: React.FC<props> = () => {
  const userData = useRecoilValue(userAtom);
  const isSuperAdmin = !!userData?.data?.isSuperAdmin;
  return (
    <SidebarMenu
      items={isSuperAdmin ? items : itemsAdmin}
      bottomItems={isSuperAdmin ? bottomItemsSuperAdmin : []}
      card={userData.data}
    />
  );
};

export default Sidebar;
